import { Link } from "react-router-dom";
import { GraduationCap, Phone, Mail, MapPin } from "lucide-react";
import { SERVICES } from "../../data/services";
import { SyncStatus } from "./SyncStatus";

export function Footer() {
	return (
		<footer className="bg-slate-950 text-slate-300 border-t border-slate-800">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
				<div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
					<div>
						<Link to="/" className="flex items-center gap-2">
							<span className="grid place-items-center h-9 w-9 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 text-white">
								<GraduationCap className="h-5 w-5" />
							</span>
							<span className="font-heading font-extrabold text-lg text-white">
								SchoolXpert<span className="text-emerald-400">360</span>
							</span>
						</Link>
						<p className="mt-4 text-sm text-slate-400 leading-relaxed">
							Turn your school into a growth engine. More visibility. More enquiries.
							More admissions. More growth.
						</p>
					</div>

					<div>
						<h4 className="font-heading font-semibold text-white mb-4">Services</h4>
						<ul className="space-y-2 text-sm">
							{SERVICES.slice(0, 6).map((s) => (
								<li key={s.id}>
									<Link to={`/services/${s.id}`} className="hover:text-emerald-400 transition-colors">{s.title}</Link>
								</li>
							))}
						</ul>
					</div>

					<div>
						<h4 className="font-heading font-semibold text-white mb-4">Company</h4>
						<ul className="space-y-2 text-sm">
							<li><Link to="/contact" className="hover:text-emerald-400">Contact</Link></li>
							<li><Link to="/privacy-policy" className="hover:text-emerald-400">Privacy Policy</Link></li>
							<li><Link to="/terms" className="hover:text-emerald-400">Terms &amp; Conditions</Link></li>
						</ul>
					</div>

					<div>
						<h4 className="font-heading font-semibold text-white mb-4">Get in touch</h4>
						<ul className="space-y-3 text-sm text-slate-400">
							<li className="flex items-center gap-2"><Phone className="h-4 w-4 text-emerald-400" /> +91 98765 43210</li>
							<li className="flex items-center gap-2"><Mail className="h-4 w-4 text-emerald-400" /> grow@schoolxpert360.com</li>
							<li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-emerald-400 mt-0.5" /> Serving schools across India</li>
						</ul>
						<div className="mt-4"><SyncStatus /></div>
					</div>
				</div>

				<div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
					<p>© {new Date().getFullYear()} SchoolXpert360. All rights reserved.</p>
					<p>100% Admission Assurance* &nbsp;·&nbsp; 50 Admissions Assured for Preschool Launch*</p>
				</div>
			</div>
		</footer>
	);
}
